export default {
  setApi(state, api) {
    state.api = api;
  },
  setAction(state, action) {
    state.action = action;
  },
};
